var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankStatementAnalyzer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28471_115448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6459 0.617188L0.6875 5.41198V7.90649H21.3125V5.39875L10.6459 0.617188ZM19.9375 6.53149H2.0625V6.276L10.6666 2.1333L19.9375 6.28923V6.53149ZM2.0625 17.5315H19.9375V18.9065H2.0625V17.5315ZM0.6875 19.9377H21.3125V21.3127H0.6875V19.9377ZM2.40625 9.28149H3.78125V16.1565H2.40625V9.28149ZM18.2188 9.28149H19.5938V16.1565H18.2188V9.28149ZM14.0938 9.28149H15.4688V16.1565H14.0938V9.28149ZM6.53125 9.28149H7.90625V16.1565H6.53125V9.28149ZM10.3125 9.28149H11.6875V16.1565H10.3125V9.28149Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28471_115448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankStatementAnalyzer);
export default __webpack_public_path__ + "static/media/BankStatementAnalyzer.42077275ffc48caf2163831894871160.svg";
export { ForwardRef as ReactComponent };